import * as React from 'react';
import { useSelector } from 'react-redux';
import { UIText1 } from '@cian/ui-kit';
import { FormCardLayout } from '../../../components/RequestFormV2/FormCardLayout';
import { selectPage, selectPageExtra } from '../../../selectors/analytics';
import { trackRequestFormShowSuccess } from '../../../utils/analytics/trackRequestFormShowSuccess';

const image = 'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-desk-5.png';
const imageMobile = 'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-mob-5.jpg';

export const RequestFormSuccess = () => {
  const page = useSelector(selectPage);
  const extra = useSelector(selectPageExtra);

  React.useEffect(() => {
    trackRequestFormShowSuccess(page, extra);
  }, [page, extra]);

  return (
    <FormCardLayout
      dataTestId="RequestFormV2Success"
      question="Заявка отправлена"
      image={image}
      imageMobile={imageMobile}
      verticallyCenteredContent={true}
    >
      <UIText1>Наш консультант перезвонит в течение дня</UIText1>
    </FormCardLayout>
  );
};
